'use strict';

var tslib_es6 = require('./_chunks/tslib.es6-DSduP8Mp.js');
var classValidator = require('class-validator');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var classValidator__namespace = /*#__PURE__*/_interopNamespace(classValidator);

function MinString(minString, validationOptions) {
    const options = Object.assign(Object.assign({}, validationOptions), { context: { minString } });
    return (target, propertyName) => {
        classValidator.registerDecorator({
            name: 'minString',
            target: target.constructor,
            propertyName,
            constraints: [minString],
            options,
            validator: {
                validate(value) {
                    return (typeof value === 'string' &&
                        typeof minString === 'string' &&
                        value >= minString);
                },
                defaultMessage() {
                    return '$property must not be less than "$constraint1"';
                },
            },
        });
    };
}
function MaxString(maxString, validationOptions) {
    const options = Object.assign(Object.assign({}, validationOptions), { context: { maxString } });
    return (target, propertyName) => {
        classValidator.registerDecorator({
            name: 'maxString',
            target: target.constructor,
            propertyName,
            constraints: [maxString],
            options,
            validator: {
                validate(value) {
                    return (typeof value === 'string' &&
                        typeof maxString === 'string' &&
                        value <= maxString);
                },
                defaultMessage() {
                    return '$property must not be greater than "$constraint1"';
                },
            },
        });
    };
}
/**
 *
 * @returns true if the property value is different from a whitespace string, null and undefined
 */
function IsNotEmpty(validationOptions) {
    const options = Object.assign({}, validationOptions);
    return (target, propertyName) => {
        classValidator.registerDecorator({
            name: 'isNotEmpty',
            target: target.constructor,
            propertyName,
            constraints: [],
            options,
            validator: {
                validate(value) {
                    if (typeof value === 'string') {
                        return value.trim() !== '';
                    }
                    return value != null;
                },
                defaultMessage() {
                    return '$property is required';
                },
            },
        });
    };
}
/**
 * Range
 * @param {string} [type] "number" | "DateTime" | "string" (optional)
 * @param {number | string | Date} minValue
 * @param {number | string | Date} maxValue
 */
function Range(...arguments_) {
    const [type, minValue, maxValue] = arguments_.length === 3
        ? arguments_
        : [typeof arguments_[0], ...arguments_];
    const isDate = `${type}`.endsWith('DateTime');
    const minFunction = type === 'number'
        ? Min(+minValue)
        : isDate
            ? MinDate(new Date(minValue))
            : MinString(`${minValue}`);
    const maxFunction = type === 'number'
        ? Max(+maxValue)
        : isDate
            ? MaxDate(new Date(maxValue))
            : MaxString(`${maxValue}`);
    return (target, key) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        minFunction(target, key);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        maxFunction(target, key);
    };
}
const IsDefined = () => classValidator__namespace.IsDefined({ context: {} });
const IsOptional = () => classValidator__namespace.IsOptional({ context: {} });
// Type decorators
const IsBoolean = () => classValidator__namespace.IsBoolean({ context: {} });
const IsString = () => classValidator__namespace.IsString({ context: {} });
const IsDate = () => classValidator__namespace.IsDate({ context: {} });
const IsDateString = () => classValidator__namespace.IsDateString({ strict: true });
const IsTime = () => classValidator__namespace.IsMilitaryTime({ context: {} });
const IsInt = () => classValidator__namespace.IsInt({ context: {} });
const IsNumberString = (options) => classValidator__namespace.IsNumberString(options, { context: Object.assign({}, options) });
function IsDecimal(options) {
    return (target, propertyName) => {
        classValidator.registerDecorator({
            target: target.constructor,
            propertyName,
            constraints: [options],
            validator: IsDecimalConstraint,
        });
    };
}
let IsDecimalConstraint = class IsDecimalConstraint {
    // eslint-disable-next-line class-methods-use-this
    validate(value, validationArguments) {
        if (typeof value === 'number') {
            return Number.isFinite(value);
        }
        const options = validationArguments
            .constraints[0];
        return classValidator__namespace.isDecimal(value, options);
    }
    // eslint-disable-next-line class-methods-use-this
    defaultMessage() {
        return '$property must be a number or a decimal string';
    }
};
IsDecimalConstraint = tslib_es6.__decorate([
    classValidator.ValidatorConstraint({ async: false, name: 'isDecimal' })
], IsDecimalConstraint);
const Min = (min) => classValidator__namespace.Min(min, { context: { min } });
const Max = (max) => classValidator__namespace.Max(max, { context: { max } });
const MinDate = (minDate) => classValidator__namespace.MinDate(minDate, { context: { minDate } });
const MaxDate = (maxDate) => classValidator__namespace.MaxDate(maxDate, { context: { maxDate } });
const MinLength = (minLength) => classValidator__namespace.MinLength(minLength, { context: { minLength } });
const MaxLength = (maxLength) => classValidator__namespace.MaxLength(maxLength, { context: { maxLength } });
const IsValidPhoneNumber = (region) => classValidator__namespace.IsPhoneNumber(region, { context: { region } });
const RegularExpression = (regex, translationKey) => classValidator__namespace.Matches(new RegExp(regex), {
    context: { regex, translationKey },
});
const IsEmail = (options) => classValidator__namespace.IsEmail(options, { context: Object.assign({}, options) });
const IsCreditCard = () => classValidator__namespace.IsCreditCard({ context: {} });
const IsUrl = (options) => classValidator__namespace.IsUrl(options, { context: Object.assign({}, options) });
const IsArray = () => classValidator__namespace.IsArray({ context: {} });
const IsEnum = (entity) => classValidator__namespace.IsEnum(entity, { context: { entity } });
/* eslint-enable @typescript-eslint/no-explicit-any */

exports.IsArray = IsArray;
exports.IsBoolean = IsBoolean;
exports.IsCreditCard = IsCreditCard;
exports.IsDate = IsDate;
exports.IsDateString = IsDateString;
exports.IsDecimal = IsDecimal;
exports.IsDefined = IsDefined;
exports.IsEmail = IsEmail;
exports.IsEnum = IsEnum;
exports.IsInt = IsInt;
exports.IsNotEmpty = IsNotEmpty;
exports.IsNumberString = IsNumberString;
exports.IsOptional = IsOptional;
exports.IsString = IsString;
exports.IsTime = IsTime;
exports.IsUrl = IsUrl;
exports.IsValidPhoneNumber = IsValidPhoneNumber;
exports.Max = Max;
exports.MaxDate = MaxDate;
exports.MaxLength = MaxLength;
exports.MaxString = MaxString;
exports.Min = Min;
exports.MinDate = MinDate;
exports.MinLength = MinLength;
exports.MinString = MinString;
exports.Range = Range;
exports.RegularExpression = RegularExpression;
//# sourceMappingURL=decorators.js.map
